export default "__VITE_ASSET__BPe13dos__"